import { EmptyState, EmptyStateProps, STATUSPAGE } from '@repo/ui';
import { Card, CardBody } from 'reactstrap';

import {
  EmptyStateIllustration,
  ErrorStateIllustration,
  InitialStateIllustration,
  LoadingStateIllustration,
} from './illustrations';

export type ContentStateStatus = STATUSPAGE;

interface IContentStateProps {
  status: ContentStateStatus;
  title?: string;
  description?: string;
  action?: EmptyStateProps['action'];
  className?: string;
  minHeight?: number;
}

const defaultMessages: Record<
  ContentStateStatus,
  Pick<IContentStateProps, 'title' | 'description'>
> = {
  [STATUSPAGE.INITIAL]: {
    title: 'Aplique os filtros para pesquisar',
    description:
      'Selecione os filtros desejados e clique em filtrar para visualizar os resultados.',
  },
  [STATUSPAGE.LOADING]: {
    title: 'Carregando informações...',
    description: 'Aguarde enquanto buscamos os dados para você.',
  },
  [STATUSPAGE.DONE]: {
    title: 'Nenhum dado encontrado',
    description: 'Não encontramos resultados para os filtros informados.',
  },
  [STATUSPAGE.ERROR]: {
    title: 'Erro ao carregar dados',
    description:
      'Ocorreu um problema ao buscar as informações. Tente novamente.',
  },
};

const illustrations: Record<ContentStateStatus, JSX.Element> = {
  [STATUSPAGE.INITIAL]: <InitialStateIllustration />,
  [STATUSPAGE.LOADING]: <LoadingStateIllustration />,
  [STATUSPAGE.DONE]: <EmptyStateIllustration />,
  [STATUSPAGE.ERROR]: <ErrorStateIllustration />,
};

export const ContentState = ({
  status,
  title,
  description,
  action,
  className = '',
  minHeight = 320,
}: IContentStateProps) => {
  const messages = defaultMessages[status];

  return (
    <Card className={`mb-3 ${className}`}>
      <CardBody
        className="d-flex align-items-center"
        style={{ minHeight }}
        aria-live="polite"
        aria-busy={status === STATUSPAGE.LOADING}
      >
        <EmptyState
          title={title || messages.title}
          description={description || messages.description}
          illustration={illustrations[status]}
          action={action}
          paddingY={3}
        />
      </CardBody>
      <style>{`
        .content-state-spinner {
          transform-origin: 60px 60px;
          animation: contentStateSpin 1.2s linear infinite;
        }

        @keyframes contentStateSpin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </Card>
  );
};
